import PubSub from "@web/stores/PubSub";

export const usePubSub = () => {
  return PubSub.getInstance();
};
